'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Button = require('../../library/Buttons/Button.js');
var DialogTitle = require('../../library/PageElements/DialogTitle.js');
var DialogActions = require('../../node_modules/@material-ui/core/esm/DialogActions/DialogActions.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Dialog = require('../../node_modules/@material-ui/core/esm/Dialog/Dialog.js');
var DialogContent = require('../../node_modules/@material-ui/core/esm/DialogContent/DialogContent.js');
var Divider = require('../../node_modules/@material-ui/core/esm/Divider/Divider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  dialogTitle: {
    padding: '24px 24px 16px'
  },
  actions: {
    margin: 24
  },
  dialogContent: {
    paddingBottom: 32
  }
};
var ConfirmationDialog = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ConfirmationDialog, _PureComponent);

  function ConfirmationDialog() {
    classCallCheck(this, ConfirmationDialog);

    return possibleConstructorReturn(this, getPrototypeOf(ConfirmationDialog).apply(this, arguments));
  }

  createClass(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          messageTitle = _this$props.messageTitle,
          children = _this$props.children,
          onCancelClick = _this$props.onCancelClick,
          onConfirmClick = _this$props.onConfirmClick,
          cancelButtonMessage = _this$props.cancelButtonMessage,
          confirmButtonMessage = _this$props.confirmButtonMessage,
          confirmButtonColor = _this$props.confirmButtonColor,
          classes = _this$props.classes;
      return React__default["default"].createElement(Dialog["default"], {
        fullWidth: true,
        disableBackdropClick: true,
        open: open,
        onClose: function onClose() {
          return onCancelClick();
        }
      }, React__default["default"].createElement(DialogTitle, {
        className: classes.dialogTitle
      }, messageTitle), ObjectHelper.isPresent(children) && React__default["default"].createElement(DialogContent["default"], {
        className: classes.dialogContent
      }, children), React__default["default"].createElement(Divider["default"], null), React__default["default"].createElement(DialogActions["default"], {
        className: classes.actions
      }, ObjectHelper.isPresent(onCancelClick) && React__default["default"].createElement(Button, {
        className: classes.root,
        onClick: function onClick() {
          return onCancelClick();
        }
      }, cancelButtonMessage), ObjectHelper.isPresent(onConfirmClick) && React__default["default"].createElement(Button, {
        variant: "text",
        color: confirmButtonColor,
        onClick: function onClick() {
          return onConfirmClick();
        }
      }, confirmButtonMessage)));
    }
  }]);

  return ConfirmationDialog;
}(React.PureComponent)) || _class);
ConfirmationDialog.defaultProps = {
  open: false,
  messageTitle: 'Are you sure?',
  cancelButtonMessage: 'Cancel',
  confirmButtonMessage: 'Confirm',
  confirmButtonColor: 'primary'
};

module.exports = ConfirmationDialog;
